import { render, staticRenderFns } from "./Agregar.vue?vue&type=template&id=50410102&"
import script from "./Agregar.vue?vue&type=script&lang=ts&"
export * from "./Agregar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports